<template>
    <v-expansion-panels
      v-model="panel"
      multiple
    >
      <v-expansion-panel
      >
        <v-expansion-panel-header>
          <span
              :style="{
                'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`, 
                'font-size': `${FontSizeContent}px !important`,
                'font-family': FontContent
              }"
          >
            {{ question }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            class="result-html"
            :style="{
              'width': width,
              'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '0',
              '--font-size-content': `${FontSizeContent}px !important`
            }"
          >

            <v-flex
              v-html="answer" 
              class="ql-editor ql-blank"
              :style="{
                'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`, 
                'font-size': `${FontSizeContent}px !important`,
                'font-family': FontContent
              }"
              v-bind="{ [columnType]: true }"
            />
            <vue-editor 
              v-show="false"
              v-model="answer"
              :disabled="true"
              :editor-toolbar="aux"
              :style="{ 'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`, 'font-size': `500px !important` }"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
  const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]

  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import { VueEditor } from "vue2-editor"
  export default {
    components: {
      VueEditor
    },
    props: {
      content: {
        type: Object,
        required: true,
        default: null
      },
      columnType: {
        type: String,
        required: false,
        default: 'xs12'
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      panel: null,
      aux: minToolbar,
      question: '',
      answer: '',
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      text () {
        return this.data.Text ? utils.getTranslation (this.data.Text, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      width () {
        if (this.isSimulation) return `${utils.getWidthPaddingDiff(375, this.content.Padding)}px`
        if (this.isDesktop) return `${utils.getWidthPaddingDiff(this.sizeW, this.content.Padding)}px !important`
        return '100% !important'
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    watch: {
      locale () {
        this.prepareData()
      },
      'content.QAndAQuestion' () {
        this.prepareData()
      },
      'content.QAndAAnswer' () {
        this.prepareData()
      },
    },
    mounted () {
      this.prepareData()
      // var s=document.getElementsByTagName('p');
      // const p_var = 500
      // for(let i=0;i<s.length;i++)
      // {
      //     s[i].setAttribute("style","font-size:"+this.FontSizeContent+"px");
      // }
    },
    methods: {
      prepareData () {
        if (this.content.QAndAQuestion) this.question = utils.getTranslation(this.content.QAndAQuestion, this.locale)
        if (this.content.QAndAAnswer) this.answer = utils.getTranslation(this.content.QAndAAnswer, this.locale)
      },
    },
  }
</script>
<style>
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>
